import React from "react";

const BaseContext = React.createContext("base");

export default BaseContext;
